import { render, staticRenderFns } from "./DisplayPriceCard.vue?vue&type=template&id=d72a8a32&scoped=true"
import script from "./DisplayPriceCard.vue?vue&type=script&lang=js"
export * from "./DisplayPriceCard.vue?vue&type=script&lang=js"
import style0 from "./DisplayPriceCard.vue?vue&type=style&index=0&id=d72a8a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72a8a32",
  null
  
)

export default component.exports